@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<kb-gallery>
  @for (card of attributes.cards; track card) {
    <section
      kbGalleryPage
      kb-card
      [appEditorId]="card.editorId"
    >
      <kb-picture
        slot="picture"
        [appOgImage]="card.attributes.medium.attributes"
        [picture]="imageToPicture(card.attributes.medium.attributes, standardAspectRatio).sources"
        [alt]="card.attributes.medium.attributes.alt"
        [rootColumns]="4"
        [appEditorId]="card.attributes.medium.editorIds?.src"
      ></kb-picture>
      @if (card.attributes.headline) {
        <h3 [appEditorId]="card.editorIds?.headline" slot="title" kb-heading type="bar">
          {{ card.attributes.headline }}
        </h3>
      }
      <div slot="content">
        @if (card.attributes.subline) {
          <h4 kb-heading [appEditorId]="card.editorIds?.subline">{{card.attributes.subline}}</h4>
        }
        <p kb-paragraph [appEditorId]="card.editorIds?.text">{{ card.attributes.text }}</p>
        @if (card.attributes.link) {
          <a kb-standalone-link class="more-link"
            [kbRouterOrExternalLink]="card.attributes.link.attributes.url"
            [attr.target]="card.attributes.link.attributes.target"
          >
            @if (card.attributes.link.attributes.label) {
              {{ card.attributes.link.attributes.label }}
            } @else {
              <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
            }
          </a>
        }
      </div>
    </section>
  }
</kb-gallery>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
